<template>
  <div id="app">
    <div id="header">
      <h1>Metaphrase</h1>
      <input
        type="text"
        id="doc-title"
        placeholder="Your document title"
        v-model="title"
      />
    </div>
    <IO
      :title="title"
      :paragraphs="paragraphs"
      :paragraphOrder="paragraphOrder"
      :languages="languages"
      @initParagraphs="initParagraphs"
    />
    <div id="language-list" class="row">
      <p v-for="(language, index) in languages" :key="index" class="box">
        {{ language }}
      </p>
      <div class="box">
        <Button
          v-if="!this.addLanguageInputVisible"
          @click="
            () => {
              this.addLanguageInputVisible = true;
            }
          "
          >Add language</Button
        >
        <input
          type="text"
          v-if="addLanguageInputVisible"
          v-model="newLanguage"
          @blur="addLanguage"
          @keydown.enter="blur"
          placeholder="New language"
        />
      </div>
    </div>
    <Editor
      :languages="languages"
      :paragraphs="paragraphs"
      :paragraphOrder="paragraphOrder"
      @textChange="onTextChange"
      @addParagraph="addParagraph"
    />
  </div>
</template>

<script>
import Editor from "./components/Editor";
import IO from "./components/IO";

export default {
  name: "App",
  components: {
    Editor,
    IO
  },
  data() {
    return {
      title: "",
      languages: [],
      newLanguage: "",
      paragraphs: {},

      addLanguageInputVisible: false

      // languages: ["English", "French"],
      // paragraphs: {
      //   "0": { English: "hello", French: "aaaaaaaaaa", order: 0 },
      //   "1": { English: "how", French: "comment", order: 1 },
      //   "2": { English: "you", French: "vous", order: 3 },
      //   "3": { English: "are", French: "allez", order: 2 }
      // }
    };
  },
  computed: {
    paragraphOrder() {
      const paragraphs = this.paragraphs;
      return Object.keys(paragraphs).sort((a, b) => {
        return paragraphs[a].order - paragraphs[b].order;
      });
    },
    currentId() {
      return Object.keys(this.paragraphs).reduce((acc, curr) => {
        const current = parseInt(curr);
        const previous = parseInt(acc);
        return current > previous ? current : previous;
      }, -1);
    }
  },
  methods: {
    /**
     * Initializes a new document based on imported file or raw text.
     */
    initParagraphs(doc) {
      this.title = doc.title;
      this.paragraphs = { ...doc.paragraphs };

      const langs = [];
      for (const id in doc.paragraphs) {
        for (const language in doc.paragraphs[id]) {
          if (language !== "order" && !langs.includes(language)) {
            langs.push(language);
          }
        }
      }
      this.languages = [...langs];
    },

    /**
     * Updates a paragraph in `paragraphs` when its corresponding text box is edited.
     */
    onTextChange(id, language, value) {
      this.paragraphs[id][language] = value;
    },

    /**
     * Adds a new language to the end.
     */
    addLanguage() {
      // TODO: show an error when you try to add a language that already exists
      if (!this.newLanguage || this.languages.includes(this.newLanguage))
        return;
      this.languages.push(this.newLanguage);
      this.newLanguage = "";
      this.addLanguageInputVisible = false;
    },
    blur(ev) {
      ev.preventDefault();
      ev.target.blur();
    },

    /**
     * Adds a new blank paragraph at the index. If there is no index, adds to the end.
     */
    addParagraph(index) {
      if (index === undefined) {
        const newIndex = this.currentId + 1;
        this.$set(this.paragraphs, newIndex, {
          order: this.paragraphOrder.length
        });
        this.languages.forEach(language => {
          this.$set(this.paragraphs[newIndex], language, "");
        });
      } else {
        // TODO: case where there is index
      }
    }
  },
  mounted() {}
};
</script>

<style>
/* Reset */
body,
ul {
  padding: 0;
  margin: 0;
}
* {
  box-sizing: border-box;
}

/* General app-wide styles */
.row {
  display: flex;
}
.box {
  display: flex;
  width: 100%;
  max-width: 33%;
  box-sizing: border-box;
}
.ui {
  font-family: monospace;
  font-size: 1rem;
}
input[type="text"],
textarea {
  border: 0;
  border: 1px solid #ddd;
  padding: 5px;
}
input[type="text"]:hover,
textarea:hover {
  border-color: #777;
}

input[type="text"]:focus,
textarea:focus {
  border-color: black;
}
textarea {
  width: 100%;
  padding: 5px;
}

/* App.vue */
#app {
  padding: 40px;
  padding-top: 40px;
  position: relative;
}
#header {
  margin-bottom: 40px;
}
h1 {
  margin-bottom: 0.2rem;
}
#doc-title {
  border: 0;
  border-bottom: 1px solid transparent;
  font-size: 24px;
}
#doc-title:hover,
#doc-title:focus {
  border-color: black;
}
#language-list p {
  font-weight: 700;
}
#language-list .box {
  align-items: center;
}
</style>
